import { getLgvStatusIcons } from "../../util/helper/helperFunctions";

const MaxZoomLGVIcon = ({ status, vehicleNumber, angle, alarmName, isFollowing }) => {
  const getTextRotation = (angle) => {
    const normalized = ((angle % 360) + 360) % 360;
    const rot = (180 - normalized + 360) % 360;
    return rot <= 180 ? rot : rot - 360;
  };

  const getVehicleNumberLength = () => {
    const position = {
      1: { top: "2px", left: "3px", size:'6px' },
      2: { top: "2px", left: "1px", size:'6px' },
      3: { top: "3px", left: "0px", size: '4.5px'}
    };
    return position[String(vehicleNumber).length];
  };

  const { top, left, size } = getVehicleNumberLength();
  const containerSize = 9;
  const iconWidth = 20;
  const iconHeight = 10;

  return (
    <div
      style={{
        width: `${containerSize}px`,
        height: `${containerSize}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: `rotate(${(angle + 180) % 360}deg)`,
        transformOrigin: "center center",
        pointerEvents: "none",
        position: "relative"
      }}
    >
      <div
        style={{
          width: `${iconWidth}px`,
          height: `${iconHeight}px`,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          transformOrigin: "center center"
        }}
      >
        <img
          src={getLgvStatusIcons(
            status === "Alarm" && alarmName === "LGV In Manual"
              ? "LGV In Manual"
              : status
          )}
          alt="LGV"
          style={{
            width: "100%",
            height: "100%",
            display: "block"
          }}
        />
        <p
          style={{
            position: "absolute",
            top,
            left,
            transform: `rotate(${getTextRotation(angle)}deg)`,
            transformOrigin: "center center",
            fontSize: size,
            color: "white",
            pointerEvents: "auto",
            margin: 0,
            lineHeight: 1,
            textAlign: "center"
          }}
        >
          {vehicleNumber}
        </p>
      </div>
      {isFollowing && (
      <span id="lgv-wrapper-circle" style={{position:'absolute', top:'-7px', right:'15px'}}>
        <span className="lgv-wrapper-circle-outer"></span>
        <span className="lgv-wrapper-circle-inner"></span>
      </span>
    )}
    </div>
  );
};

export default MaxZoomLGVIcon;

